import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import Modal from "@/components/ui/Modal.vue";

  interface Props {
    isOpen: boolean;
    currentBuyers: {
      firstBuyer?: string;
      secondBuyer?: string;
    } | null;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EditBuyersModal',
  props: {
    isOpen: { type: Boolean },
    currentBuyers: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const firstBuyer = ref<string>("");
  const secondBuyer = ref<string>("");

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen && props.currentBuyers) {
        firstBuyer.value = props.currentBuyers.firstBuyer || "";
        secondBuyer.value = props.currentBuyers.secondBuyer || "";
      } else if (isOpen) {
        firstBuyer.value = "";
        secondBuyer.value = "";
      }
    },
    { immediate: true }
  );

  const close = () => {
    emit("close");
  };

  const confirm = () => {
    const buyers = {
      firstBuyer: firstBuyer.value.trim() || undefined,
      secondBuyer: secondBuyer.value.trim() || undefined,
    };

    emit("confirm", buyers);
    close();
  };

const __returned__ = { props, emit, firstBuyer, secondBuyer, close, confirm, ref, watch, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})